var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDatePicker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 105,
  height: 18,
  viewBox: "0 0 105 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M101 0C103.209 0 105 1.79086 105 4V14C105 16.2091 103.209 18 101 18H4C1.79086 18 0 16.2091 0 14V4C0 1.79086 1.79086 0 4 0H101Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgDatePicker;